import axios from "axios";

const extractData = (response) => response?.data?.data ?? response?.data ?? null;

const tryRequest = async (request) => {
  try {
    const response = await request();
    return extractData(response);
  } catch (error) {
    return null;
  }
};

const mapFinanceTypeToCustomtype = (financeType) => {
  switch (financeType) {
    case "inventory_finance":
      return "Inventory finance";
    case "payable_finance":
      return "Payables finance";
    case "receivable_finance":
      return "Receivables finance";
    case "payments":
      return "Payments";
    default:
      return null;
  }
};

export const resolveFinanceRouteState = async (id, initialState) => {
  if (initialState?._id && initialState?.customtype) {
    return initialState;
  }

  if (!id) return initialState ?? null;

  const genericFinance = await tryRequest(() => axios.get(`/v1/admin/finance/single/${id}`));
  if (genericFinance) {
    return {
      ...genericFinance,
      _id: genericFinance?._id ?? id,
      customtype:
        initialState?.customtype ??
        genericFinance?.customtype ??
        mapFinanceTypeToCustomtype(genericFinance?.financeType) ??
        "Factoring",
    };
  }

  const workingCapital = await tryRequest(() =>
    axios.get(`/v1/admin/get-single-finance-trade-credit/${id}`),
  );
  if (workingCapital) {
    return { ...workingCapital, _id: workingCapital?._id ?? id, customtype: "Working Capital" };
  }

  const creditLine = await tryRequest(() =>
    axios.get(`/v1/admin/get-single-finance-credit-line/${id}`),
  );
  if (creditLine) {
    return { ...creditLine, _id: creditLine?._id ?? id, customtype: "Credit Line" };
  }

  const invoice = await tryRequest(() => axios.get(`/v1/admin/get-single-finance-invoice/${id}`));
  if (invoice) {
    return { ...invoice, _id: invoice?._id ?? id, customtype: "Factoring" };
  }

  const payment = await tryRequest(() => axios.get(`/v1/admin/finance/pay/single/${id}`));
  if (payment) {
    return { ...payment, _id: payment?._id ?? id, customtype: "Payments" };
  }

  return initialState ?? null;
};

export const resolveInvoiceRouteState = async (id, initialState) => {
  if (initialState?._id && initialState?.customtype) {
    return initialState;
  }

  if (!id) return initialState ?? null;

  const flexInvoice = await tryRequest(() => axios.get(`/v1/admin/flex/get-invoice/${id}`));
  if (flexInvoice) {
    return {
      ...flexInvoice,
      _id: flexInvoice?._id ?? id,
      customtype: initialState?.customtype ?? flexInvoice?.customtype ?? "Factoring",
    };
  }

  const financeInvoice = await tryRequest(() =>
    axios.get(`/v1/admin/get-single-finance-invoice/${id}`),
  );
  if (financeInvoice) {
    return { ...financeInvoice, _id: financeInvoice?._id ?? id, customtype: "Factoring" };
  }

  const workingCapital = await tryRequest(() =>
    axios.get(`/v1/admin/get-single-finance-trade-credit/${id}`),
  );
  if (workingCapital) {
    return { ...workingCapital, _id: workingCapital?._id ?? id, customtype: "Working Capital" };
  }

  const creditLine = await tryRequest(() =>
    axios.get(`/v1/admin/get-single-finance-credit-line/${id}`),
  );
  if (creditLine) {
    return { ...creditLine, _id: creditLine?._id ?? id, customtype: "Credit Line" };
  }

  return initialState ?? null;
};

export const resolveTransactionRouteState = async (id, initialState) => {
  if (initialState?._id) {
    return initialState;
  }

  if (!id) return initialState ?? null;

  const transaction = await tryRequest(() => axios.get(`/v1/admin/transaction/${id}`));
  if (transaction) {
    return { ...transaction, _id: transaction?._id ?? id };
  }

  const fxTransfer = await tryRequest(() =>
    axios.get(`/v1/admin/transaction/get_single_fx_transfer/${id}`),
  );
  if (fxTransfer) {
    return { ...fxTransfer, _id: fxTransfer?._id ?? id };
  }

  const fundRequest = await tryRequest(() =>
    axios.get(`/v1/admin/transaction/fund_request/single/${id}`),
  );
  if (fundRequest) {
    return { ...fundRequest, _id: fundRequest?._id ?? id };
  }

  return initialState ?? null;
};

export const resolveAccountRouteState = async (id, initialState) => {
  if (initialState?._id) {
    return initialState;
  }

  if (!id) return initialState ?? null;

  const payload = await tryRequest(() => axios.get(`/v1/admin/get-full-business-details/${id}`));
  const business = payload?.business;

  if (business) {
    return { ...business, _id: business?._id ?? id };
  }

  return initialState ?? null;
};
